<ion-avatar class="u-avatar" [class.u-avatar--small]="size === 'small'" [class.u-avatar--medium]="size === 'medium'"
  [class.u-avatar--large]="size === 'large'">
  <img class="image" alt="Imagem de perfil do usuário" [lazyLoad]="src" [defaultImage]="imagemDefault"
    [errorImage]="imagemDefault" />
</ion-avatar>
